import topic from '../topic';
export const mdtfAPI = {
  getMdtfs: topic.mdtfTopic + '/getMdtfs',
  stockOut: topic.mdtfTopic + '/mdtfStockOut',
  stockIn: topic.mdtfTopic + '/mdtfStockIn',
  stpr_stock_out: topic.mdtfTopic + '/stprStockOut'
};
